import styled from '@emotion/styled';
import { Card } from '@mui/material';
import { shouldForwardProps } from '../../utils';
import { Breakpoint, getBreakpointValue, isCompact } from '../../types';

export const LoginCardContainer = styled(Card, shouldForwardProps)<{
    breakpoint: Breakpoint;
}>`
    margin-top: ${({ theme, breakpoint }) => theme.spacing(isCompact(breakpoint) ? 4 : 5)};
    margin-bottom: ${({ theme }) => theme.spacing(2)};
    padding-top: ${({ theme }) => theme.spacing(3)};
    padding-bottom: ${({ theme }) => theme.spacing(4)};
    padding-left: ${({ theme, breakpoint }) =>
        theme.spacing(getBreakpointValue(breakpoint, 3, 5, 8))};
    padding-right: ${({ theme, breakpoint }) =>
        theme.spacing(getBreakpointValue(breakpoint, 3, 5, 8))};

    border-radius: ${({ breakpoint }) => (isCompact(breakpoint) ? '0px' : '12px')};

    max-width: ${({ breakpoint }) => (isCompact(breakpoint) ? '100%' : '552px')};
    height: fit-content;
    overflow-y: auto;
`;
